import React, { useEffect, useState } from 'react';
import './styles.css';

export default function Admin() {
  const [orders, setOrders] = useState([]);
  
  function handleSendEmail(orderId) {
    const confirmSend = window.confirm("Es-tu sûr de vouloir envoyer le mail de commande prête ?");
    if (!confirmSend) return;

    fetch(`/api-admin/orders/${orderId}/send-ready-email`, {
      method: 'POST',
    })
      .then(res => res.json())
      .then(updated => {
        alert('Email envoyé avec succès !');
        updateOrderCounts(orderId, updated);
      })
      .catch(err => {
        console.error(err);
        alert("Erreur lors de l'envoi de l'email.");
      });
  }

  function handleSendSMS(orderId) {
    const confirmSend = window.confirm("Es-tu sûr de vouloir envoyer le SMS de commande prête ?");
    if (!confirmSend) return;

    fetch(`/api-admin/orders/${orderId}/send-ready-sms`, {
      method: 'POST',
    })
      .then(res => res.json())
      .then(updated => {
        alert('SMS envoyé avec succès !');
        updateOrderCounts(orderId, updated);
      })
      .catch(err => {
        console.error(err);
        alert("Erreur lors de l'envoi du SMS.");
      });
  }

  function handleChangeStatus(orderId, newStatus) {
    fetch(`/api-admin/orders/${orderId}/status`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ status: newStatus }),
    })
      .then(res => {
        if (!res.ok) throw new Error('Erreur lors de la mise à jour du statut');
        return res.json();
      })
      .then(updatedOrder => {
        setOrders(prev =>
          prev.map(o => (o.id === orderId ? { ...o, status: updatedOrder.status } : o))
        );
      })
      .catch(err => {
        console.error(err);
        alert('Erreur lors de la mise à jour du statut de la commande.');
      });
  }

  function updateOrderCounts(orderId, updatedData) {
    setOrders(prev =>
      prev.map(o =>
        o.id === orderId
          ? {
              ...o,
              email_sent_count: updatedData.email_sent_count,
              sms_sent_count: updatedData.sms_sent_count,
            }
          : o
      )
    );
  }

  function handleToggleValideCE(orderId, newValue) {
    fetch(`/api-admin/orders/${orderId}/valide-cse`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ valide_ce: newValue ? 1 : 0 }),
    })
      .then(res => {
        if (!res.ok) throw new Error('Erreur mise à jour');
        return res.json();
      })
      .then(updatedOrder => {
        setOrders(prev =>
          prev.map(o => (o.id === orderId ? { ...o, valide_ce: updatedOrder.valide_ce } : o))
        );
      })
      .catch(err => {
        console.error(err);
        alert('Erreur lors de la mise à jour de la validation CSE.');
      });
  }

  useEffect(() => {
    fetch('/api-admin/orders')
      .then(res => res.json())
      .then(setOrders);
  }, []);

  return (
    <div className="admin-container container">
      <h1>Commandes reçues</h1>
      <div className="legend">
        <span
          className="legend-item order-status-closed"
          title="Commande terminée (status = 'closed')"
        >
          🧾 Commande terminée
        </span>
        <span
          className="legend-item order-status-ready-cse"
          title="Commande prête de type CSE (status = 'ready' et paiement = 'cse')"
        >
          ✅ Commande prête (CSE)
        </span>
      </div>

      <table className="admin-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>ID Compagny</th>
            <th>Code CSE</th>
            <th>Date</th>
            <th>Nom</th>
            <th>Prénom</th>
            <th>Email</th>
            <th>Téléphone</th>
            <th>Paiement</th>
            <th>Commentaire</th>
            <th>Notification Préférence</th>
            {/* <th>Envoyer Mail ?</th> */}
            {/* <th>Total avant remise (€)</th> */}
            <th>Total (€)</th>
            <th>PDF</th>
            <th>Validé CSE ?</th>
            <th>Statut</th>
            <th>Mail - Commande prête (envoyés)</th>
            <th>SMS - Commande prête (envoyés)</th>
            {/* <th>Articles commandés</th> */}
          </tr>
        </thead>
        <tbody>
          {orders.map(order => (
              <tr
                key={order.id}
                className={
                  order.status === 'closed'
                    ? 'order-status-closed'
                    : order.status === 'ready' && order.paiement === 'cse'
                    ? 'order-status-ready-cse'
                    : ''
                }
              >

              <td>{order.id}</td>
              <td>{order.id_compagny}</td>
              <td>{order.code_cse}</td>
              <td>{new Date(order.created_at).toLocaleString()}</td>
              <td>{order.nom}</td>
              <td>{order.prenom}</td>
              <td>{order.email}</td>
              <td>{order.telephone}</td>
              <td>{order.paiement}</td>
              <td>{order.comment}</td>
              <td>{order.notification_preference}</td>
              {/* <td>{order.envoyer_mail}</td> */}
              {/* <td>{Number(order.total_avant_remise).toFixed(2)}</td> */}
              <td>{Number(order.total).toFixed(2)}</td>
              <td><a href={`/pdfs/${order.pdf_filename}`}>Download</a></td>
              <td>
                {order.paiement === 'cse' ? (
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={order.valide_ce === 1}
                      onChange={() => handleToggleValideCE(order.id, !order.valide_ce)}
                    />
                    <span className="slider"></span>
                  </label>
                ) : (
                  <span style={{ color: '#888' }}>—</span>
                )}
              </td>
              <td>
                <select
                  value={order.status || 'En attente'}
                  onChange={(e) => handleChangeStatus(order.id, e.target.value)}
                >
                  <option value="running">En cours</option>
                  <option value="ready">Prête</option>
                  <option value="waiting_payment">Attente paiement</option>
                  <option value="closed">Terminée</option>
                </select>
              </td>
              <td>
                {order.paiement === "magasin" ? (
                  <div>
                    <button onClick={() => handleSendEmail(order.id)} className="btn-mail">
                      Envoyer mail
                    </button>
                    <div style={{ fontSize: '0.8em', marginTop: '5px' }}>
                      {order.email_sent_count || 0} envoyé(s)
                    </div>
                  </div>
                ) : (
                  <span>N/A (car commande CSE)</span>
                )}
              </td>
              <td>
                {order.paiement === "magasin" ? (
                  <div>
                    <button onClick={() => handleSendSMS(order.id)} className="btn-sms">
                      Envoyer SMS
                    </button>
                    <div style={{ fontSize: '0.8em', marginTop: '5px' }}>
                      {order.sms_sent_count || 0} envoyé(s)
                    </div>
                  </div>
                ) : (
                  <span>N/A (car commande CSE)</span>
                )}
              </td>
              {/* <td>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr>
                      <th style={{ borderBottom: '1px solid #ccc', textAlign: 'left' }}>Quantité</th>
                      <th style={{ borderBottom: '1px solid #ccc', textAlign: 'left' }}>Category</th>
                      <th style={{ borderBottom: '1px solid #ccc', textAlign: 'left' }}>Produit</th>
                      <th style={{ borderBottom: '1px solid #ccc', textAlign: 'left' }}>Définition</th>
                      <th style={{ borderBottom: '1px solid #ccc', textAlign: 'left' }}>Prix (€)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {order.produits.map((p, i) => (
                      <tr key={i}>
                        <td style={{ padding: '2px 5px' }}>{p.quantite}</td>
                        <td style={{ padding: '2px 5px' }}>{p.category}</td>
                        <td style={{ padding: '2px 5px' }}>{p.nom}</td>
                        <td style={{ padding: '2px 5px' }}>{p.definition}</td>
                        <td style={{ padding: '2px 5px' }}>{Number(p.prix_unitaire).toFixed(2)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </td> */}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
